import { GoogleMap, Polygon as GoogleMapPolygon } from '@capacitor/google-maps';
import { MSLatLng } from 'src/app/models/map.model';
import { PreserveStringAlias } from 'src/app/utils/alias.utils';
import { msLatLngToLatLng } from 'src/app/utils/google-map/google-map.utils';
import { PolygonConfig } from './polygon.config';

type PolygonId = string & PreserveStringAlias;

export class Polygon {
  private config: PolygonConfig;
  private polygonId: PolygonId | null = null;

  private constructor(private map: GoogleMap) {}

  static async create(map: GoogleMap, config: PolygonConfig): Promise<Polygon> {
    const polygon = new Polygon(map);
    await polygon.add(config);

    return polygon;
  }

  async update(updateOpts: Partial<PolygonConfig>): Promise<void> {
    if (!this.polygonId) {
      return;
    }

    const opts = { ...this.config, ...updateOpts };

    await this.remove();
    await this.add(opts);
  }

  async remove(): Promise<void> {
    if (!this.polygonId) {
      return;
    }

    await this.map.removePolylines([this.polygonId]);
    this.polygonId = null;
  }

  private async add(config: PolygonConfig): Promise<void> {
    const markerConfig: GoogleMapPolygon = this.convertPolygonConfigToGoogleMapPolygon(config);
    const id = await this.map.addPolygons([markerConfig])[0];

    this.config = config;
    this.polygonId = id;
  }

  private convertPolygonConfigToGoogleMapPolygon(config: PolygonConfig): GoogleMapPolygon {
    const path = config.path.map((point: MSLatLng) => msLatLngToLatLng(point));

    return {
      paths: path,
      strokeWeight: config.width,
      strokeColor: config.color,
      geodesic: config.geodesic
    };
  }
}
